import React, { useState, useEffect } from "react";
import {
	Col,
	Container,
	FormGroup,
	Row,
	Card,
	CardImg,
	CardBody,
	CardText,
	Badge,
	Spinner,
} from "reactstrap";
import "assets/scss/website/app.scss";
import compoundImg from "assets/images/bg.png";
import compoundLogo from "assets/images/compound.png";
import { MetaTags } from "react-meta-tags";
import { Link } from "react-router-dom";
import ProfileService from "services/Website/ProfileService";
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import { addInterestUnit } from "store/Auth/actions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import InterestServices from "services/Website/InterestServices";
import developerdImg from "assets/images/developer_logo.png";
import { useTranslation } from "react-i18next";
import CallModal from "components/Website/Cards/CallModal";
import BuyUnitModal from "components/Website/Cards/BuyUnit";
import UploadReceiptModal from "components/Website/Cards/UploadReceiptModal";
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from "reactstrap";
import DeleteModal from "./DeleteModal";
import DealService from "services/Website/DealService";

const UnitCard = (props) => {
	const { item, key, profile } = props;
	const { t } = useTranslation();
	const profileService = new ProfileService();
	const dealService = new DealService();
	const [buyModal, setBuyModal] = useState(false);
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);
	const [formState, setFormState] = useState({
		media_id: "",
		media_id_path: "",
	});
	const [deleteModal, setDeleteModal] = useState(false);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [toggleInterest, setToggleInterest] = useState(false);

	useEffect(() => {
		const id = parseInt(item?.id);
		// setInterested(AuthData.interestsUnits.includes(id))
	}, [AuthData.interestsUnits]);

	const isInterested = () => {
		const id = parseInt(item?.id);
		return AuthData.interestsUnits.includes(id);
	};

	// const interestHandler =  (id) => {
	//     setToggleInterest(true)
	//     const data = {
	//         unit_id: id
	//     }
	//     if (!isInterested()) {
	//          dispatch(addInterestUnit(id, data,"add",setToggleInterest))
	//     //   setToggleInterest(false)

	//     } else {
	//             dispatch(addInterestUnit(id, data, "delete",setToggleInterest,updateProfileInterest,profile))
	//         // setToggleInterest(false)

	//         // if (profile) {
	//         //     updateProfileInterest()
	//         // }
	//     }
	// }

	return (
		<div className="websitPages h-100" key={key}>
			<div className="comCard h-100">
				<div
					className="m-0 h-100"
					style={{ justifyContent: "space-between" }}
					onClick={() => setBuyModal(true)}>
					<div>
						<div
							className="deal-top"
							style={{
								background: getBackGround(item?.status),
							}}>
							<Badge
								className="font-size-13 m-0 text-white"
								style={{ background: "none" }}>
								{item?.status}
							</Badge>
							<Dropdown
								className="dropdownWidth"
								style={{ borderRadius: "8px" }}
								color="light"
								isOpen={dropdownOpen}
								toggle={(e) => {
									e.stopPropagation();
									setDropdownOpen((prevState) => !prevState);
								}}>
								<DropdownToggle caret>
									<i className="fa fa-ellipsis-v text-dark fa-lg"></i>
								</DropdownToggle>
								<DropdownMenu>
									<DropdownItem
										className="text-danger"
										onClick={(e) => {
											setDeleteModal(true);
										}}>
										Remove Deal
									</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</div>
						{item?.images?.length > 0 ? (
							item?.images?.map((img, index) => {
								if (index === 0) {
									return <CardImg key={index} src={img.path}></CardImg>;
								}
							})
						) : (
							<CardImg src={compoundImg}></CardImg>
						)}
						{item?.developer?.media?.path ? (
							<img src={item.developer.media.path} className="imgAbsolute" />
						) : (
							<img src={developerdImg} className="imgAbsolute" />
						)}
						<CardBody>
							<Badge className="bgBadgeResale  badgeAbsolute font-size-12">
								{item.title}
							</Badge>

							<div>
								<CardText
									tag="h4"
									className="font-size-16"
									style={{ color: "#3a3335", fontWeight: 800 }}>
									{item?.name[`${AuthData.lang}`]
										? item?.name[`${AuthData.lang}`]
										: item?.name?.en}
								</CardText>
								<CardText
									tag="h4"
									className="mb-1 d-flex justify-content-between">
									{item?.price ? (
										<span className="font-size-16 pt-1">
											{toCurrency(item.price)} {currency?.currency_code}
										</span>
									) : (
										<span className="font-size-16 pt-1">
											{toCurrency(item?.payment_plan.total_price)}{" "}
											{currency?.currency_code}
										</span>
									)}
									{item?.size && (
										<Badge className="badge p-2  font-size-12 ">
											{item?.finishing_type?.name[`${AuthData.lang}`]
												? item?.finishing_type?.name[`${AuthData.lang}`]
												: item?.finishing_type?.name.en}
										</Badge>
									)}
									{item?.total_built_up_area && (
										<Badge className="badge p-2  font-size-12 ">
											{item?.finishing_type?.name}
										</Badge>
									)}
								</CardText>

								<div className="d-flex py-2">
									{!!item.bedrooms && (
										<p className="w-100 text-black my-0">
											<i className="fa me-1 fa-bed"></i> {item.bedrooms}{" "}
											{t("beds")}
										</p>
									)}
									{item.bathrooms && (
										<p className="w-100 text-black my-0">
											<i className="fa me-1 fa-shower"></i> {item.bathrooms}{" "}
											{t("baths")}
										</p>
									)}
									{item.size && (
										<p className="w-100 text-black my-0">
											<i className="fa me-1 fa-exchange-alt"> </i>
											{item?.size
												? parseInt(item.size).toFixed(0)
												: parseInt(item.total_built_up_area).toFixed(0)}{" "}
											{t("sqm")}
										</p>
									)}
								</div>
								<p className="w-100 text-black m-0">
									<i className="fas me-1 fa-map-marker-alt"></i>
									{item?.address ? (
										<>
											{item?.address[AuthData.lang]
												? item?.address[AuthData.lang]
												: item.address?.en}{" "}
											,
											{item?.area.name[AuthData.lang]
												? item?.area.name[AuthData.lang]
												: item.area.name?.en}{" "}
											,
											{item?.city.name[AuthData.lang]
												? item?.city.name[AuthData.lang]
												: item.city.name?.en}
										</>
									) : (
										<>
											{item?.area?.name} ,
											{item?.location?.City[AuthData.lang]
												? item?.location?.City[AuthData.lang]
												: item?.location?.City?.en}{" "}
											,
											{item?.location?.governorate[AuthData.lang]
												? item?.location?.governorate[AuthData.lang]
												: item?.location.governorate?.en}
										</>
									)}
								</p>
							</div>
						</CardBody>
					</div>
					<div className="d-flex px-3 mb-3">
						<div className="w-100">
							<button
								type="button"
								style={{
									background: "var(--primary-color)",
									borderColor: "var(--primary-color)",
								}}
								className="w-100 btn btn-primary text-center">
								Buy the Unit
							</button>
						</div>
					</div>
				</div>
			</div>

			{buyModal && (
				<BuyUnitModal
					modal={buyModal}
					setModal={setBuyModal}
					details={{ ...item, deal_id: item.deal_id }}
					unitType=""
					deposit="1000"
					propsList={props}
				/>
			)}

			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name[`${AuthData.lang}`]}
					deletedItem={item}
					params={{
						deal_id: item?.deal_id,
						status: "Removed",
					}}
					setShouldGetData={props?.setShouldGetData}
					modelService={dealService}
					onCloseModal={() => setDeleteModal(false)}
				/>
			)}
		</div>
	);
};

const getBackGround = (status) => {
	return status === "Contacted"
		? "#db1fdb"
		: status === "Uncontacted"
		? "#74788d"
		: status === "Lost"
		? "#bf060b"
		: status === "Won"
		? "#34e38f"
		: status === "Open"
		? "#50a5f1"
		: status === "Unreachable"
		? "#556ee6"
		: "#f1874c";
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};
export default UnitCard;
